var app = angular.module('leonardo');

var NotificationService = function($rootScope) {
  var service = {};
  service.notify = function(type, title, message, timeout) {
    toastr[type](message, title, timeout ? { timeOut : timeout} : undefined );
  };

  service.searchErrorValue = function(error, key, index) {
    if (angular.isArray(error) || angular.isObject(error)) {
      angular.forEach(error, function (value, indexError) {
        service.searchErrorValue(value, indexError, key);
      });
    }
    else {
      if (!isNull(error) && !error.startsWith('Invalid page')) {
        var keyError = !angular.isNumber(key) ? key : index;
        if(keyError === 'key' && error === "This field must be unique.") {
          service.notify('error', 'This field name already exists. Please choose a different name');
        }
        else if(keyError === 'email' && error === "Enter a valid email address.") {
          service.notify('error', error);
        }
        else if(keyError === 'email' && error === "The email address you have provided is already in use. Please use a different email address.") {
          service.notify('error', error);
        }
        else if(keyError === 'email') {
          service.notify('error', 'Email address must be unique.');
        }
        else if(keyError === 'email:notexists' && (error === "This email does not exist" || error === "User account is Disabled")) {
          service.notify('error', 'Oops! Looks like the Email entered does not match our records.</br>' + 'Please try again or contact help@leonardo247.com for further assistance.');
        }
        else if(keyError === 'active_templates' && error === "This list may not be empty.") {
          var state = $rootScope.actualLocation?.split('/');
          if (state.length > 0) {
            if (state[1] == "workflows") {
              this.notify('error', 'Workflow launch cannot be performed when no tasks are included. Please relaunch with active tasks in order to proceed.');
            }
            else if (state[1] == "unit-turn") {
              this.notify('error', 'Unit Workflow launch cannot be performed when no tasks are included. Please relaunch with active tasks in order to proceed.');
            }
            else {
              this.notify('error', error);
            }
          }
        }
        else {
          service.notify('error', error);
        }
      }
    }
  };

  service.error = function(error) {
    if (!isNull(error) && error.data !== undefined) {
      if (angular.isObject(error.data)) {
        angular.forEach(error.data, function(value, index){
          service.searchErrorValue(value, index);
        });
      }
      else if (!isNull(error.data) && !error.data.startsWith('Invalid page')) {
        service.notify('error', error.data);
      }
      else {
        service.notify('error', 'An unexpected error has occurred!');
      }
    }
    else {
      if (angular.isObject(error)) {
        angular.forEach(error, function(value, index){
          service.searchErrorValue(value, index);
        });
      }
      else if (error && !error.startsWith('Invalid page')) {
        service.notify('error', error);
      }
      else {
        service.notify('error', 'An unexpected error has occurred!');
      }
    }
  };

  return service;
};

app.factory('NotificationService', ['$rootScope',  NotificationService]);
